module.exports = __webpack_public_path__ + "img/pizza-token.5934c0d7.svg";